module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.query.account))]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('Inputs', {
    staticStyle: {
      "width": "180px",
      "margin-top": "0",
      "float": "left"
    },
    attrs: {
      "type": 'code'
    },
    on: {
      "inputText": _vm.getCode,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('GetCode', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": 1,
      "data": {
        'countryCode': _vm.$route.query.countryCode,
        'phone': _vm.$route.query.account
      }
    }
  })], 1), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'newpassword'
    },
    on: {
      "inputText": _vm.getPassword,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": 'reset',
      "data": {
        code: _vm.code,
        password: _vm.password
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  }), _vm._v(" "), _c('Foot', {
    staticStyle: {
      "margin-top": "25px",
      "margin-bottom": "45px"
    },
    attrs: {
      "type": 'or Sign in',
      "isEmail": _vm.isEmail ? true : false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3d8f400"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Forgotpassword.vue
// module id = 746
// module chunks = 1